module.exports = __webpack_public_path__ + "static/media/SmartShop_4-543w.e40726c9.png";